import { render, staticRenderFns } from "./FristenPage.vue?vue&type=template&id=3b3c14fb&"
import script from "./FristenPage.vue?vue&type=script&lang=js&"
export * from "./FristenPage.vue?vue&type=script&lang=js&"
import style0 from "./FristenPage.vue?vue&type=style&index=0&id=3b3c14fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports